"use client";
export { Span as default } from "../../../_Builtin/Basic";
